import { render, staticRenderFns } from "./destination.vue?vue&type=template&id=2b52164e&scoped=true&"
import script from "./destination.vue?vue&type=script&lang=js&"
export * from "./destination.vue?vue&type=script&lang=js&"
import style0 from "./destination.vue?vue&type=style&index=0&id=2b52164e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b52164e",
  null
  
)

export default component.exports